import { IsArray, IsBoolean, IsDate, IsDefined, IsString, ValidateNested } from "class-validator";

import type { VehicleTypeCoefficient } from "./VehicleTypeCoefficient";

export class DynamicPricingInfo {
    @IsArray()
    @IsDefined()
    @ValidateNested({ each: true })
    public vehicleCoefficients: VehicleTypeCoefficient[];

    @IsDate()
    @IsDefined()
    public date: Date;

    @IsString()
    @IsDefined()
    public message: string;

    @IsBoolean()
    @IsDefined()
    public isBlacklistedDate: boolean;
}
